export default theme => ({
    card: {
      maxWidth: 350
    },
    cardHeader: {
      textAlign: "left",
      marginBottom: "-30px"
    },
    cardContent: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      minHeight: 80
    },
    cardData: {
      textAlign: "left",
      width: "100%"
    },
    cardInfo: {
      textAlign: "left"
    },
    linkItem: {
      marginBottom: "8px"
    }
  });
  